'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var Radio = (function (_React$Component) {
    _inherits(Radio, _React$Component);

    function Radio() {
        _classCallCheck(this, Radio);

        _get(Object.getPrototypeOf(Radio.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(Radio, [{
        key: 'render',
        value: function render() {
            var componentClass = (0, _classnames2['default'])('Radio', {
                'Radio--disabled': this.props.disabled,
                'Radio--inline': this.props.inline,
                error: this.props.errors.length
            }, this.props.className);
            var props = (0, _blacklist2['default'])(this.props, 'className', 'label', 'children', 'inline', 'errors');

            return _react2['default'].createElement(
                'div',
                { className: componentClass },
                _react2['default'].createElement(
                    'label',
                    null,
                    _react2['default'].createElement('input', _extends({ type: 'radio', className: 'Radio__input' }, props)),
                    _react2['default'].createElement(
                        'span',
                        {
                            className: (0, _classnames2['default'])('Radio__label', {
                                'Radio__label-lg': this.props.size === 'lg'
                            })
                        },
                        this.props.label
                    )
                ),
                this.props.checked ? _react2['default'].createElement(
                    'div',
                    { className: 'Radio__children' },
                    this.props.children
                ) : false
            );
        }
    }]);

    return Radio;
})(_react2['default'].Component);

Radio.propTypes = {
    checked: _propTypes2['default'].bool,
    className: _propTypes2['default'].string,
    disabled: _propTypes2['default'].bool,
    errors: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
    inline: _propTypes2['default'].bool,
    label: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].node]),
    size: _propTypes2['default'].oneOf(['lg'])
};

Radio.defaultProps = {
    errors: []
};

module.exports = Radio;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/Radio.js
// module id = 325
// module chunks = 0